import { ComponentProps, JSXElementConstructor } from 'react';
import {
  LayoutProps,
  resolveLayoutStyles,
  shouldForwardLayoutProp,
} from './layout-spacing-props';
import { styled } from './styled';

export const styledWithLayoutProps = <
  C extends JSXElementConstructor<ComponentProps<C>>,
>(
  component: C,
) =>
  styled(component, {
    shouldForwardProp: (prop) => shouldForwardLayoutProp(String(prop)),
  })<LayoutProps>(({ theme, ...layoutProps }) =>
    resolveLayoutStyles(theme, layoutProps),
  );
